import React from 'react'
import {
  Wrapper,
  Icon,
  Title,
  Description,
  ActionWrapper,
  CustomDescription,
} from './SidebarEmpty.styles'

interface SidebarEmptyProps {
  icon?: React.ElementType
  title: string
  description?: string | React.ReactNode
  action?: React.ReactNode
}

export const SidebarEmpty = (props: SidebarEmptyProps) => {
  const { icon, title, description, action } = props

  const renderDescription = () => {
    if (typeof description === 'string') {
      return <Description>{description}</Description>
    }

    return <CustomDescription>{description}</CustomDescription>
  }

  return (
    <Wrapper>
      {icon && <Icon as={icon} />}
      {title && <Title>{title}</Title>}
      {description && renderDescription()}
      {action && <ActionWrapper>{action}</ActionWrapper>}
    </Wrapper>
  )
}
